import { ChevronDown } from 'lucide-react';

/** Vertical connector with a downward arrowhead, drawn between step cards (n8n-style). */
export function Connector(): React.ReactElement {
  return (
    <div className="flex flex-col items-center py-1.5" aria-hidden="true">
      {/* Solid line + bolder arrowhead — clearly visible against the dotted canvas. */}
      <div className="h-8 w-0.5 rounded-full bg-grey-200" />
      <ChevronDown className="-mt-2.5 size-6 text-grey-200" strokeWidth={2} />
    </div>
  );
}
